import { Check } from 'lucide-react';
import { BILLING_STRINGS } from '../constants/billing-strings';

const COPY = BILLING_STRINGS.PURCHASE;

export interface PlanBenefitsProps {
  /** Seats the plan includes. */
  includedSeats: number;
  /** Two columns for a wide card, one in a narrow one. */
  columns?: 1 | 2;
}

/**
 * What a data-room plan includes, as a checked list (2026-09-22 design).
 *
 * One list for the plan cards and the Billing & Info page, so a benefit is
 * never added to one and forgotten on the other. Only what the product
 * actually does, and only what the plan adds: "Due Diligence platform access"
 * is MYN-111.5's wording. Profile sharing and team management are free-tier
 * (System Designer, 2026-10-01), and the design's "investor tracking" and
 * "priority support" are left out because nothing delivers them.
 */
export function PlanBenefits({ includedSeats, columns = 1 }: PlanBenefitsProps) {
  const items = [
    COPY.BENEFIT_DATA_ROOM,
    includedSeats === 1 ? COPY.BENEFIT_SEAT_ONE : COPY.BENEFIT_SEATS.replace('{count}', String(includedSeats)),
  ];

  return (
    <ul className={`grid gap-x-6 gap-y-3 text-sm ${columns === 2 ? 'sm:grid-cols-2' : ''}`}>
      {items.map((item) => (
        <li key={item} className="text-text-primary flex items-start gap-2.5">
          <Check aria-hidden="true" className="text-green mt-0.5 h-4 w-4 shrink-0" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
